import { render, staticRenderFns } from "./pointSetUp.vue?vue&type=template&id=63092038&scoped=true"
import script from "./pointSetUp.vue?vue&type=script&lang=js"
export * from "./pointSetUp.vue?vue&type=script&lang=js"
import style0 from "./pointSetUp.vue?vue&type=style&index=0&id=63092038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63092038",
  null
  
)

export default component.exports